import { inherits as _inherits, createSuper as _createSuper, createClass as _createClass, classCallCheck as _classCallCheck } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { IconPresentation } from '@lsg/shared';
import { createElement, Component } from 'react';

/** @deprecated , replaced by union type (Date: 09.11.2021) */

var Sizes;

(function (Sizes) {
  Sizes["SMALL"] = "small";
  Sizes["MEDIUM"] = "medium";
  Sizes["LARGE"] = "large";
})(Sizes || (Sizes = {}));
/** @deprecated , replaced by union type (Date: 09.11.2021) */


var Colors;

(function (Colors) {
  Colors["DEFAULT"] = "default";
  Colors["PRIMARY"] = "primary";
  Colors["SECONDARY"] = "secondary";
  Colors["ERROR"] = "error";
  Colors["SUCCESS"] = "success";
  Colors["NOTE"] = "note";
  Colors["DISABLED"] = "disabled"; // NONINTERACTIVE = "noninteractive", // Todo: the color option "noninterative" should be evaluate again. See also color definition in lsg.shared

  Colors["BLACK"] = "black";
  Colors["WHITE"] = "white";
  Colors["ANTHRACITE"] = "anthracite";
  Colors["PRIMARY_1"] = "primary-1";
  Colors["PRIMARY_2"] = "primary-2";
  Colors["SECONDARY_1"] = "secondary-1";
  Colors["SECONDARY_2"] = "secondary-2";
  Colors["SECONDARY_3"] = "secondary-3";
  Colors["SECONDARY_4"] = "secondary-4";
  Colors["SECONDARY_5"] = "secondary-5";
  Colors["SECONDARY_6"] = "secondary-6";
})(Colors || (Colors = {}));
/** @deprecated , replaced by union type (Date: 09.11.2021) */


var Variants;

(function (Variants) {
  Variants["OUTLINE"] = "outline";
  Variants["SOLID"] = "solid";
})(Variants || (Variants = {}));

var Icon = /*#__PURE__*/function (_Component) {
  _inherits(Icon, _Component);

  var _super = _createSuper(Icon);

  function Icon() {
    _classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/createElement(IconPresentation, Object.assign({}, this.props, {
        transform: undefined,
        hover: undefined
      }));
    }
  }]);

  return Icon;
}(Component);

Icon.displayName = "Icon";
Icon.defaultProps = {
  color: "default",
  size: "small",
  variant: "outline"
};
/** @deprecated */

Icon.Colors = Colors;
/** @deprecated */

Icon.Sizes = Sizes;
/** @deprecated */

Icon.Variants = Variants;

export { Colors, Icon, Sizes, Variants };
